import { motion } from "framer-motion";
import HeroSection from "../HeroSection";
import MyPortfolio from "../MyPortfolio";
import MySkills from "../MySkills";
import Certificates from "../Certificates";
import AboutMe from "../AboutMe";
import ContactMe from "../ContactMe";
import Footer from "../Footer";
import Navbar from "../Navbar";
import BackToTop from "../../../components/BackToTop";
import ScrollProgress from "../../../components/ScrollProgress";
import NavDots from "../../../components/NavDots";

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <ScrollProgress />
      <Navbar />
      <HeroSection />
      <MyPortfolio />
      <MySkills />
      <Certificates />
      <AboutMe />
      <ContactMe />
      <Footer />
      <BackToTop />
      <NavDots />
    </motion.div>
  );
}
